import { sdkRequest } from '@eventbrite/http';
import { AsyncActionOptions, Organization } from '../types';

export const createOrganization = async ({
    name,
    publicId,
    locale,
    options,
}: {
    name: string;
    publicId: string;
    locale: string;
    options?: AsyncActionOptions;
}): Promise<Organization> => {
    if (options?.testingFlags.shouldError) {
        await new Promise((resolve) => setTimeout(resolve, 1700));
        throw new Error('Error creating organization');
    }

    return sdkRequest(`/api/v3/organizations/`, {
        method: 'POST',
        body: JSON.stringify({
            owner_id: publicId,
            organization: {
                name,
                locale,
                vertical: 'default',
            },
        }),
    });
};
